import {Upload} from 'tus-js-client';
import {httpsCallable} from 'firebase/functions';
import {functions} from '../lib/firebase';

export function uploadErrorMessage(error) {
 const code=String(error?.code || '');
 if(code.includes('not-found'))return 'The video upload service needs to be deployed. Contact your administrator.';
 if(code.includes('deadline-exceeded'))return 'Preparing the upload took too long. Retry here; any transferred video data will be resumed.';
 if(code.includes('permission-denied') || code.includes('failed-precondition'))return error.message;
 return 'The upload connection was interrupted. Keep this page open and choose Retry upload to resume.';
}
// Credentials are for one owned video. The Bunny API key never reaches the browser.
export function createResumableVideoUpload({file,paperId,videoTitle,onProgress,onState,onSuccess,onError}) {
 const uploadId=Array.from(crypto.getRandomValues(new Uint32Array(4)),n=>n.toString(16).padStart(8,'0')).join('');
 const authorize=httpsCallable(functions,'createBunnyUpload',{timeout:120000});
 let upload=null,credentials=null,stopped=false,paused=false,starting=false,offset=0,authorization=null;
 const getCredentials=()=>{
  if(authorization)return authorization;
  authorization=authorize({uploadId,paperId,fileName:file.name,size:file.size,videoTitle}).then(response=>{
   const data=response.data;
   if(!data?.videoId || !data?.libraryId || !data?.signature || data.endpoint!=='https://video.bunnycdn.com/tusupload')throw new Error('Invalid upload credentials');
   credentials=data;offset=data.serverNow-Date.now();return data;
  }).finally(()=>{authorization=null;});return authorization;
 };
 const start=async()=>{
  if(stopped)return;paused=false;if(starting)return;starting=true;onState('Preparing secure upload…');
  try{
   if(!credentials || Date.now()+offset>credentials.expires*1000-60000)await getCredentials();
   if(stopped||paused)return;
   if(!upload)upload=new Upload(file,{
    endpoint:credentials.endpoint,chunkSize:8*1024*1024,retryDelays:[0,2000,5000,10000,30000],
    storeFingerprintForResuming:false,removeFingerprintOnSuccess:true,
    metadata:{filetype:file.type || 'application/octet-stream',title:videoTitle || file.name},
    onBeforeRequest:async request=>{
     if(Date.now()+offset>credentials.expires*1000-60000)await getCredentials();
     request.setHeader('AuthorizationSignature',credentials.signature);request.setHeader('AuthorizationExpire',String(credentials.expires));
     request.setHeader('LibraryId',String(credentials.libraryId));request.setHeader('VideoId',credentials.videoId);
    },
    onProgress:(sent,total)=>{if(!stopped&&!paused)onProgress(sent,total);},
    onError:error=>{if(!stopped&&!paused)onError(error);},
    onSuccess:()=>{if(!stopped)onSuccess(credentials.videoId,credentials.libraryId);},
   });
   onState('Uploading directly to Bunny…');upload.start();
  }catch(error){if(!stopped&&!paused)onError(error);}finally{starting=false;}
 };
 return {start,pause:async()=>{paused=true;await upload?.abort();},cancel:()=>{stopped=true;return upload?.abort();}};
}
